function daysInMonth(year, month) {
  return new Date(year, month, 0).getDate();
}

export default function MonthChart({ data, year, month, onDayClick }) {
  const totalDays = daysInMonth(year, month);
  const parJour = {};
  data.forEach((d) => {
    parJour[Number(d.jour)] = Number(d.nb);
  });

  const values = [];
  for (let jour = 1; jour <= totalDays; jour++) {
    values.push(parJour[jour] || 0);
  }
  const max = Math.max(...values, 1);

  return (
    <div className="month-chart-wrap">
      <div className="month-chart">
        {values.map((v, idx) => (
          <div
            key={idx}
            className="month-chart-bar"
            title={`Jour ${idx + 1} : ${v} verre${v > 1 ? "s" : ""} — clique pour le détail`}
            onClick={() => onDayClick && onDayClick(idx + 1)}
          >
            <div className="bar-inner" style={{ height: `${(v / max) * 100}%` }} />
          </div>
        ))}
      </div>
      <div className="month-chart-axis">
        <span>1</span>
        <span>{Math.round(totalDays / 2)}</span>
        <span>{totalDays}</span>
      </div>
    </div>
  );
}